/**
 * @param {{ preset: string; compact?: boolean }} props
 */
export function ButtonPresetPreview({ preset, compact = false }) {
  return (
    <div
      className="branding-preset-preview portal-branded"
      data-button-preset={preset}
      style={{ pointerEvents: 'none' }}
    >
      <button type="button" className="btn-primary">
        Primary
      </button>
      <button type="button" className="btn-secondary">
        Secondary
      </button>
      <button type="button" className="btn-danger">
        Danger
      </button>
      <button type="button" className="btn-link">
        Link
      </button>
      {!compact ? (
        <span className="muted small" style={{ width: '100%', marginTop: '0.15rem' }}>
          All button types in this set
        </span>
      ) : null}
    </div>
  );
}
